import React from 'react';
import { useRightRail } from '../../contexts/RightRailContext';

const RightRail: React.FC = () => {
  const { buttons, activePanelId, togglePanel } = useRightRail();

  return (
    <div className="flex-shrink-0 w-12 flex flex-col items-center gap-1 pt-3 px-1 bg-base-200 border-l border-base-300 h-full">
      {buttons.map((btn, idx) => {
        const isActive = activePanelId === btn.id;
        return (
          <React.Fragment key={btn.id}>
            {idx > 0 && <div className="w-7 border-t border-base-300 my-0.5" />}
            <div className="relative group">
              <button
                onClick={() => togglePanel(btn.id)}
                className={`
                  w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-150 relative
                  ${isActive
                    ? 'bg-primary text-primary-content shadow-sm'
                    : 'text-base-content/60 hover:bg-base-300 hover:text-base-content'
                  }
                `}
                aria-label={btn.label}
              >
                {btn.icon}
                {!!btn.badge && btn.badge > 0 && (
                  <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-error text-white text-[10px] font-bold rounded-full flex items-center justify-center px-0.5 leading-none">
                    {btn.badge > 99 ? '99+' : btn.badge}
                  </span>
                )}
              </button>

              {/* Tooltip */}
              <div className="absolute right-12 top-1/2 -translate-y-1/2 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-50">
                <div className="bg-neutral text-neutral-content text-xs font-medium px-2 py-1 rounded whitespace-nowrap shadow-lg">
                  {btn.label}
                  <div className="absolute left-full top-1/2 -translate-y-1/2 border-4 border-transparent border-l-neutral" />
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default RightRail;
